import { render, staticRenderFns } from "./product_edit_auth_date.vue?vue&type=template&id=1e8f5744&scoped=true&"
import script from "./product_edit_auth_date.vue?vue&type=script&lang=js&"
export * from "./product_edit_auth_date.vue?vue&type=script&lang=js&"
import style0 from "./product_edit_auth_date.vue?vue&type=style&index=0&id=1e8f5744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f5744",
  null
  
)

export default component.exports